<app-kiosk-order-status-display *ngIf="activeOrder && activeOrder.total > 0" [(selectViewOrder)]="selectViewOrder"></app-kiosk-order-status-display>
<app-kiosk-order-active *ngIf="selectViewOrder" [(selectViewOrder)]="selectViewOrder" [(startCheckout)]="startCheckout"></app-kiosk-order-active>
<app-kiosk-checkout *ngIf="startCheckout" [(displayCheckout)]="startCheckout"></app-kiosk-checkout>
